<template>
  <transition name="fade">
    <div
      @click="closePopup"
      v-if="$store.getters.showDialog"
      :class="['auth-mask']"
    ></div>
  </transition>
  <transition name="slide">
    <div class="auth-container" v-if="$store.getters.showDialog">
     
      <t-button
        @click="closePopup"
        :image="$config.iconCloseMenu"
        :rounded="true"
        :textual="true"
        :imageStyle="'height:25px !important; width:25px !important; min-width:25px; margin:unset'"
        style="margin: 10px;"
      ></t-button>
      <div class="container">
        <keep-alive>
          <component
            :is="$store.getters.dialogComponent"
            v-bind="$store.getters.dialogSettings.props"
          ></component>
        </keep-alive>
      </div>
    </div>
  </transition>
</template>

<script>
import { SWITCH_DIALOG } from "../../store/actions";
import TButton from "../../../common/components/buttons/TButton.vue";
export default {
  components: { TButton },
  methods: {
    closePopup() {
      this.$store.dispatch(SWITCH_DIALOG);
      // $("body").css("overflow", "auto");
      // this.$store.getters.dialogSettings.closeAction();
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-close {
  float: left;
}
.dialog-title {
  font-family: Nunito;
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  color: #034141;
  margin-left: 10px;
}
.dialog-header {
  width: 100%;
  padding: 25px;
  height: 90px;
  border-bottom: 1px solid #e2e5e6;
}
.auth-mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  height: 100%;
  background: #000;
  opacity: 0.5;
  z-index: 10;
}

.auth-container {
  position: fixed;
  height: 100%;
  top: 0;
  right: 0;
  z-index: 11;
  width: 500px;
  padding-bottom: 48px;
  background-color: white;
  overflow: auto;

  @media screen and (max-width: 640px) {
    width: 100%;

    .close {
      display: block !important;
      position: absolute;
      top: 20px;
      left: 20px;
    }
  }

  .container {
    padding: 25px;
    margin-top: 5px !important;

    @media screen and (max-width: 600px) {
      max-width: 90%;
      padding: 25px 0px 25px 0px;
    }
  }

  .close {
    display: none;
  }

  .tabs {
    display: flex;

    button {
      @include f-subtitle1;
    }

    button:not(:last-of-type) {
      margin-right: 17px;
    }
  }
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.3s linear;
}

.slide-enter-from,
.slide-leave-to {
  transform: translate(100%, 0);
}

.fade-leave-active,
.fade-enter-active {
  transition: opacity 0.4s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
